// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BuildHost } from "./build-host";

/**
 * Provenance of a translation. Never hashed and never compared.
 */
export class BuildInfo implements flatbuffers.IUnpackableObject<BuildInfoT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): BuildInfo {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsBuildInfo(bb: flatbuffers.ByteBuffer, obj?: BuildInfo): BuildInfo {
    return (obj || new BuildInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsBuildInfo(bb: flatbuffers.ByteBuffer, obj?: BuildInfo): BuildInfo {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new BuildInfo()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  host(): BuildHost {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : BuildHost.Unspecified;
  }

  converterCommit(): string | null;
  converterCommit(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  converterCommit(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  wasmSha256(): string | null;
  wasmSha256(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  wasmSha256(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  canonicalFormat(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  schemaFingerprint(): string | null;
  schemaFingerprint(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  schemaFingerprint(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  canaryOk(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  static startBuildInfo(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addHost(builder: flatbuffers.Builder, host: BuildHost) {
    builder.addFieldInt8(0, host, BuildHost.Unspecified);
  }

  static addConverterCommit(
    builder: flatbuffers.Builder,
    converterCommitOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(1, converterCommitOffset, 0);
  }

  static addWasmSha256(builder: flatbuffers.Builder, wasmSha256Offset: flatbuffers.Offset) {
    builder.addFieldOffset(2, wasmSha256Offset, 0);
  }

  static addCanonicalFormat(builder: flatbuffers.Builder, canonicalFormat: number) {
    builder.addFieldInt16(3, canonicalFormat, 0);
  }

  static addSchemaFingerprint(
    builder: flatbuffers.Builder,
    schemaFingerprintOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(4, schemaFingerprintOffset, 0);
  }

  static addCanaryOk(builder: flatbuffers.Builder, canaryOk: boolean) {
    builder.addFieldInt8(5, +canaryOk, +false);
  }

  static endBuildInfo(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createBuildInfo(
    builder: flatbuffers.Builder,
    host: BuildHost,
    converterCommitOffset: flatbuffers.Offset,
    wasmSha256Offset: flatbuffers.Offset,
    canonicalFormat: number,
    schemaFingerprintOffset: flatbuffers.Offset,
    canaryOk: boolean,
  ): flatbuffers.Offset {
    BuildInfo.startBuildInfo(builder);
    BuildInfo.addHost(builder, host);
    BuildInfo.addConverterCommit(builder, converterCommitOffset);
    BuildInfo.addWasmSha256(builder, wasmSha256Offset);
    BuildInfo.addCanonicalFormat(builder, canonicalFormat);
    BuildInfo.addSchemaFingerprint(builder, schemaFingerprintOffset);
    BuildInfo.addCanaryOk(builder, canaryOk);
    return BuildInfo.endBuildInfo(builder);
  }

  unpack(): BuildInfoT {
    return new BuildInfoT(
      this.host(),
      this.converterCommit(),
      this.wasmSha256(),
      this.canonicalFormat(),
      this.schemaFingerprint(),
      this.canaryOk(),
    );
  }

  unpackTo(_o: BuildInfoT): void {
    _o.host = this.host();
    _o.converterCommit = this.converterCommit();
    _o.wasmSha256 = this.wasmSha256();
    _o.canonicalFormat = this.canonicalFormat();
    _o.schemaFingerprint = this.schemaFingerprint();
    _o.canaryOk = this.canaryOk();
  }

  unpackFields(...fields: string[]): BuildInfoT {
    const t = new BuildInfoT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("host")) {
      t.host = this.host();
    }
    if (fieldSet.has("converter_commit")) {
      t.converterCommit = this.converterCommit();
    }
    if (fieldSet.has("wasm_sha256")) {
      t.wasmSha256 = this.wasmSha256();
    }
    if (fieldSet.has("canonical_format")) {
      t.canonicalFormat = this.canonicalFormat();
    }
    if (fieldSet.has("schema_fingerprint")) {
      t.schemaFingerprint = this.schemaFingerprint();
    }
    if (fieldSet.has("canary_ok")) {
      t.canaryOk = this.canaryOk();
    }
    return t;
  }
}

export class BuildInfoT implements flatbuffers.IGeneratedObject {
  constructor(
    public host: BuildHost = BuildHost.Unspecified,
    public converterCommit: string | Uint8Array | null = null,
    public wasmSha256: string | Uint8Array | null = null,
    public canonicalFormat: number = 0,
    public schemaFingerprint: string | Uint8Array | null = null,
    public canaryOk: boolean = false,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const converterCommit =
      this.converterCommit !== null ? builder.createString(this.converterCommit!) : 0;
    const wasmSha256 = this.wasmSha256 !== null ? builder.createString(this.wasmSha256!) : 0;
    const schemaFingerprint =
      this.schemaFingerprint !== null ? builder.createString(this.schemaFingerprint!) : 0;

    return BuildInfo.createBuildInfo(
      builder,
      this.host,
      converterCommit,
      wasmSha256,
      this.canonicalFormat,
      schemaFingerprint,
      this.canaryOk,
    );
  }

  clone(): BuildInfoT {
    const obj = new BuildInfoT();
    obj.host = this.host;
    obj.converterCommit = this.converterCommit;
    obj.wasmSha256 = this.wasmSha256;
    obj.canonicalFormat = this.canonicalFormat;
    obj.schemaFingerprint = this.schemaFingerprint;
    obj.canaryOk = this.canaryOk;
    return obj;
  }

  equals(other: BuildInfoT): boolean {
    if (this.host !== other.host) return false;
    if (this.converterCommit !== other.converterCommit) return false;
    if (this.wasmSha256 !== other.wasmSha256) return false;
    if (this.canonicalFormat !== other.canonicalFormat) return false;
    if (this.schemaFingerprint !== other.schemaFingerprint) return false;
    if (this.canaryOk !== other.canaryOk) return false;
    return true;
  }
}

export function verifyBuildInfo(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 10, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
  } finally {
    verifier.popDepth();
  }
}
